// extracted by mini-css-extract-plugin
module.exports = {"bbbBadge":"bbbBadge_bbbBadge___iGTM","bbblink":"bbbBadge_bbblink__OOHQj"};